{
  "share": {
    "subject": "Присоединяйтесь к событию «{{title}}» на Agapella",
    "message": "Присоединяйтесь к событию «{{title}}» на Agapella\n{{url}}"
  },
  "types": {
    "retreat": "РЕТРИТ",
    "workshop": "ВОРКШОП",
    "ceremony": "ЦЕРЕМОНИЯ",
    "class": "ЗАНЯТИЕ",
    "festival": "ФЕСТИВАЛЬ",
    "meetup": "ВСТРЕЧА",
    "practice": "ПРАКТИКА"
  },
  "source": {
    "all": "Все",
    "agape": "Agapē",
    "masters": "Мастера"
  },
  "formatGroup": {
    "live": "Live",
    "events": "События"
  },
  "format": {
    "live_meditation": "Медитация онлайн",
    "guided_practice": "Практика с ведущим",
    "breathwork": "Дыхательные практики",
    "movement": "Движение",
    "somatic": "Соматическая практика",
    "sound_bath": "Звуковая ванна",
    "mantra": "Мантра и голос",
    "mindfulness": "Практика осознанности",
    "coaching_group": "Коучинг-сессия",
    "talk": "Беседа / Учение",
    "qa": "Вопросы и ответы",
    "community_circle": "Круг сообщества",
    "deep_dive": "Глубокое погружение",
    "morning_ritual": "Утренний ритуал",
    "evening_winddown": "Вечернее расслабление",
    "workshop": "Воркшоп",
    "masterclass": "Мастер-класс",
    "intensive": "Интенсив",
    "live_series": "Серия Live-сессий",
    "course_cohort": "Курс / Поток",
    "retreat_online": "Ретрит (онлайн)",
    "retreat_inperson": "Ретрит (очный)",
    "immersion": "Иммерсия / Лагерь",
    "challenge": "Челлендж",
    "ceremony": "Церемония / Круг",
    "sound_journey": "Звуковое путешествие",
    "experience_night": "Вечер опыта",
    "meetup": "Встреча (местная)",
    "private_1on1": "Сессия 1:1",
    "festival": "Фестиваль / Саммит",
    "facilitator_training": "Обучение фасилитаторов",
    "certification": "Программа сертификации"
  },
  "pathGroup": {
    "science": "Наука и Психология",
    "body": "Тело и Соматика",
    "spiritual": "Духовное"
  },
  "path": {
    "mbsr": "Доказательная осознанность",
    "stress_reset": "Стресс и выгорание",
    "anxiety": "Регуляция тревоги",
    "sleep": "Сон и восстановление",
    "focus": "Фокус и продуктивность",
    "emotional_reg": "Эмоциональная регуляция",
    "self_compassion": "Самосострадание",
    "cbt": "Практики в стиле КПТ",
    "somatic_psych": "Соматическая психология",
    "nervous_system": "Нервная система",
    "trauma_sensitive": "Работа с травмой",
    "mental_fitness": "Ментальная форма",
    "somatic_release": "Соматический релиз",
    "breath_modern": "Дыхание и CO₂",
    "vagus_toning": "Вагусный тонус",
    "mobility": "Мобильность и растяжка",
    "yin_relax": "Инь / Глубокое расслабление",
    "movement_med": "Медитация в движении",
    "qigong": "Цигун / Тайцзи",
    "posture": "Осанка и присутствие",
    "grounding": "Заземление и воплощение",
    "bioenergetic": "Биоэнергетика / Шейк",
    "heart_practice": "Практика сердца",
    "awareness": "Осознанность и присутствие",
    "intuition": "Интуиция и внутреннее руководство",
    "energy": "Практика с энергией",
    "chakras": "Чакры",
    "sound_vibration": "Звук и вибрация",
    "ritual": "Ритуал и символ",
    "nature": "Природа / Связь с землёй",
    "manifestation": "Манифестация и намерение",
    "shadow_work": "Работа с тенью"
  },
  "traditions": {
    "all": "Все традиции",
    "buddhism": "Буддизм",
    "hinduism": "Индуизм",
    "sufism": "Суфизм",
    "shaivism": "Шиваизм",
    "yoga": "Йога",
    "taoism": "Даосизм",
    "mindfulness": "Майндфулнес",
    "tantra": "Тантра"
  },
  "filter": {
    "sessionType": "Тип сессии",
    "eventType": "Тип события",
    "pathStyle": "Путь и стиль",
    "clearAll": "Сбросить всё",
    "selectedCount": "{{count}} выбрано"
  }
}
